var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("roleCertificationApplication.roleDetail"),
                isShowFollow: false,
              },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c("el-form", { ref: "form", attrs: { model: _vm.details } }, [
                  _vm.details.roleCode === "BOOKING_JP"
                    ? _c(
                        "table",
                        {
                          staticClass: "mailTable",
                          staticStyle: { width: "100%", "margin-bottom": "0" },
                        },
                        [
                          _c("colgroup", [
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.roleCode"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.roleCode)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.port"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.portCode)),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.authStatus"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.details.authStatus == "0"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "warning" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "roleCertificationApplication.applying"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "1"
                                  ? _c("el-tag", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "roleCertificationApplication.approving"
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "2"
                                  ? _c("el-tag", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "roleCertificationApplication.approved"
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "3"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "roleCertificationApplication.rejected"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.agent"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.details.jpBookingForwarderCode)
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.contactMobilePhone"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.details.contactMobilePhone)
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("roleCertificationApplication.fax")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(_vm.details.faxNo))]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "2" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.freightSendingMethod"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "keyword" } },
                                  [
                                    _c("el-checkbox", {
                                      attrs: { label: "Email", name: "type" },
                                      model: {
                                        value: _vm.emailCheck,
                                        callback: function ($$v) {
                                          _vm.emailCheck = $$v
                                        },
                                        expression: "emailCheck",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-checkbox", {
                                      attrs: { label: "Fax", name: "type" },
                                      model: {
                                        value: _vm.faxCheck,
                                        callback: function ($$v) {
                                          _vm.faxCheck = $$v
                                        },
                                        expression: "faxCheck",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.approveRemark"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.approveRemark)),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.roleCode === "BOOKING_NOT_JP"
                    ? _c(
                        "table",
                        {
                          staticClass: "mailTable",
                          staticStyle: { width: "100%", "margin-bottom": "0" },
                        },
                        [
                          _c("colgroup", [
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.roleCode"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.roleCode)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.port"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.portCode)),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.authStatus"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.details.authStatus == "0"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "warning" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "roleCertificationApplication.applying"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "1"
                                  ? _c("el-tag", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "roleCertificationApplication.approving"
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "2"
                                  ? _c("el-tag", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "roleCertificationApplication.approved"
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "3"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "roleCertificationApplication.rejected"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.contactMobilePhone"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.details.contactMobilePhone)
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("roleCertificationApplication.fax")
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(_vm.details.faxNo))]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "2" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.freightSendingMethod"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { prop: "keyword" } },
                                  [
                                    _c("el-checkbox", {
                                      attrs: { label: "Email", name: "type" },
                                      model: {
                                        value: _vm.emailCheck,
                                        callback: function ($$v) {
                                          _vm.emailCheck = $$v
                                        },
                                        expression: "emailCheck",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-checkbox", {
                                      attrs: { label: "Fax", name: "type" },
                                      model: {
                                        value: _vm.faxCheck,
                                        callback: function ($$v) {
                                          _vm.faxCheck = $$v
                                        },
                                        expression: "faxCheck",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.approveRemark"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.approvalRemark)),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.roleCode === "OUT_DG_DEC"
                    ? _c(
                        "table",
                        {
                          staticClass: "mailTable",
                          staticStyle: { width: "100%", "margin-bottom": "0" },
                        },
                        [
                          _c("colgroup", [
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.roleCode"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.roleCode)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.port"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.portCode)),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.authStatus"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.details.authStatus == "0"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "warning" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "roleCertificationApplication.applying"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "1"
                                  ? _c("el-tag", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "roleCertificationApplication.approving"
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "2"
                                  ? _c("el-tag", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "roleCertificationApplication.approved"
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "3"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "roleCertificationApplication.rejected"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.edoUnitType"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.edoUnitType)),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.edoUserName"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.edoUserName)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.edoUserIdNumber"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.edoUserIdNumber)),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.edoEmail"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.edoEmail)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.contactMobilePhone"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.details.contactMobilePhone)
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.approveRemark"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.approvalRemark)),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.details.roleCode === "IN_EDO"
                    ? _c(
                        "table",
                        {
                          staticClass: "mailTable",
                          staticStyle: { width: "100%", "margin-bottom": "0" },
                        },
                        [
                          _c("colgroup", [
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                            _vm._v(" "),
                            _c("col", { attrs: { width: "100px" } }),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.roleCode"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.roleCode)),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.port"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.portCode)),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.authStatus"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm.details.authStatus == "0"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "warning" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "roleCertificationApplication.applying"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "1"
                                  ? _c("el-tag", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "roleCertificationApplication.approving"
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "2"
                                  ? _c("el-tag", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "roleCertificationApplication.approved"
                                          )
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.details.authStatus == "3"
                                  ? _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "roleCertificationApplication.rejected"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.applyDate"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.applyDate)),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.contactMobilePhone"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.details.contactMobilePhone)
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.contactPhone"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.contactPhone)),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c(
                              "td",
                              {
                                staticClass: "column",
                                attrs: { colspan: "6" },
                              },
                              [
                                _c("span", { staticClass: "column-after" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "roleCertificationApplication.approveRemark"
                                      )
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.details.approveRemark)),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }